import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import axios from "axios"

const { Option } = Select 

/**
 * @const SelectUsuario
 * @description Select para los usuarios registrados en el sistema
 */
const SelectUsuario = (props) => {

    const { 
        value, 
        onChange = () => {}, 
        placeholder = "Seleccione el usuario", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        mode = null,
        labelInValue
    } = props

    const [ usuarios, setUsuarios ] = useState({
        itemsList: [],
        currentPage: 1,
        limit: 50,
        total: 0,
        search: null,
    })


    /**
     * @const getUsuarios
     * @description Obitiene los usaurios
     */
    const getUsuarios = ({
        currentPage, 
        limit, 
        search, 
    } = usuarios) => {

        axios.get('/usuarios', {
            params: {
                page: currentPage,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            console.log('data',data);
            setUsuarios(data.data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener los usuarios')
        })
    }

    //componentDidMount
    useEffect(() => {
        getUsuarios()
    }, [])

    


    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            mode={mode}
            onSearch={(search)=> getUsuarios({search})}
            onSelect={(usuario)=> {
                if(mode === null && !labelInValue){
                    onChange(usuario.value)
                    onSelect(usuario.value)
                }
                if(mode === null && labelInValue){
                    onChange(usuario)
                    onSelect(usuario)
                }
            }}
            onChange={(values)=>{
                if(mode === "multiple" && !labelInValue){
                    let arr = values.map(e => e.value)
                    onChange(arr)
                    onSelect(arr)
                }
                if(mode === "multiple" && labelInValue){
                    onChange(values)
                    onSelect(values)
                }
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                usuarios?.itemsList?.map(({ _id, nombre_completo, apellidos }) => <Option value={_id} key={_id}>{nombre_completo ?? ""} {apellidos ?? ""}</Option>)
            }
        </Select>
    );
}



export default SelectUsuario;